(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("dsgov", [], factory);
	else if(typeof exports === 'object')
		exports["dsgov"] = factory();
	else
		root["dsgov"] = factory();
})(self, function() {
return 